var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLikeSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 8H3.5V15H1V8ZM11.5 15H4.5V7.5985L6.021 5.317L6.4435 2.3585C6.47856 2.12056 6.59779 1.90308 6.77953 1.74555C6.96128 1.58803 7.19349 1.5009 7.434 1.5H7.5C7.8977 1.5004 8.279 1.65856 8.56022 1.93978C8.84144 2.221 8.9996 2.6023 9 3V6H13C13.5302 6.00066 14.0386 6.21159 14.4135 6.58652C14.7884 6.96145 14.9993 7.46977 15 8V11.5C14.9987 12.4279 14.6295 13.3173 13.9734 13.9734C13.3173 14.6295 12.4279 14.9987 11.5 15Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeSelected);
export default __webpack_public_path__ + "static/media/likeSelected.1739313db72ece04b86ff798ddd60fbe.svg";
export { ForwardRef as ReactComponent };